import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleButton = () => {
    const { config, googleLogin } = useAuth();
    const navigate = useNavigate();
    const ref = useRef(null);

    useEffect(() => {
        if (!config?.google_enabled || !config?.google_client_id) return;
        const handle = async (response) => {
            try {
                await googleLogin(response.credential);
                toast.success("Signed in with Google");
                navigate("/auctions");
            } catch (e) {
                toast.error(e?.response?.data?.detail || "Google sign-in failed");
            }
        };
        const init = () => {
            if (!window.google || !ref.current) return;
            window.google.accounts.id.initialize({ client_id: config.google_client_id, callback: handle });
            window.google.accounts.id.renderButton(ref.current, { theme: "outline", size: "large", width: 320 });
        };
        if (window.google) { init(); return; }
        const s = document.createElement("script");
        s.src = "https://accounts.google.com/gsi/client";
        s.async = true; s.defer = true; s.onload = init;
        document.body.appendChild(s);
    }, [config, googleLogin, navigate]);

    if (!config?.google_enabled) return null;
    return (
        <div className="mt-4">
            <div className="relative my-4 text-center">
                <span className="relative z-10 bg-card px-2 text-xs text-muted-foreground">or continue with</span>
                <div className="absolute left-0 top-1/2 h-px w-full bg-border" />
            </div>
            <div ref={ref} className="flex justify-center" data-testid="google-signin-button" />
        </div>
    );
};
